import { useCookie, useRuntimeConfig } from "#app";
import { ref, watchEffect, computed } from "vue";

export function useCookieConsentStore() {
const consentRaw = useCookie("cookiesAccepted", {
  sameSite: "lax",
  maxAge: 60 * 60 * 24 * 180,
});
const cookieConsent = ref(consentRaw.value ?? null);

const cookiesSet = computed(() => cookieConsent.value !== null);


watchEffect(() => {
  cookieConsent.value = consentRaw.value ?? null;
 // cookiesSet.value = consentRaw.value !== undefined;
});


  const loadExternalScripts = () => {
    if (cookieConsent.value === "true") {
      const config = useRuntimeConfig().public;

      // ✅ Google Analytics (gtag)
      if (config.googleAnalyticsId && !window.gtagScriptInjected) {
        const gaScript = document.createElement("script");
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${config.googleAnalyticsId}`;
        gaScript.async = true;
        document.head.appendChild(gaScript);

        gaScript.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag("js", new Date());
          gtag("config", config.googleAnalyticsId);
          window.gtagScriptInjected = true;
        };
      }

      // ✅ Google Tag Manager
      if (config.gtmId && !window.gtmInjected) {
        const gtmScript = document.createElement("script");
        gtmScript.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${config.gtmId}');
        `;
        document.head.appendChild(gtmScript);
        window.gtmInjected = true;
      }

      // ✅ Yandex Metrica
      if (config.yandexSiteVerification && !window.yandexInjected) {
        const yandexId = config.public.yandex;
        const yandexScript = document.createElement("script");
        yandexScript.innerHTML = `
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
          ym(${yandexId}, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true
          });
        `;
        // ❗ Remplace XXXXXXX par ton vrai ID Yandex (tu peux aussi le stocker dans `.env`)
        document.head.appendChild(yandexScript);
        window.yandexInjected = true;
      }

      // ✅ Facebook Pixel
      if (config.facebookPixelId && !window.fbqInjected) {
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = "2.0";
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = "https://connect.facebook.net/en_US/fbevents.js";
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, "script");

        fbq("init", config.facebookPixelId);
        fbq("track", "PageView");
        window.fbqInjected = true;
      }

      // ✅ Twitter Pixel
      if (config.twitterPixelId && !window.twqInjected) {
        !(function (e, t, n, s, u, a) {
          e.twq ||
            ((s = e.twq =
              function () {
                s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
              }),
            (s.version = "1.1"),
            (s.queue = []),
            (u = t.createElement(n)),
            (u.async = !0),
            (u.src = "https://static.ads-twitter.com/uwt.js"),
            (a = t.getElementsByTagName(n)[0]),
            a.parentNode.insertBefore(u, a));
        })(window, document, "script");

        twq("init", config.twitterPixelId);
        twq("track", "PageView");
        window.twqInjected = true;
      }

      // 🎥 YouTube → handled ailleurs (dans les iframes)
      // On débloquera les iframes dans un composant (ex: v-if="cookieConsent === 'true'")
    }
  };

  return {
    cookieConsent,
    cookiesSet,
    acceptCookies: () => {
      consentRaw.value = "true";
      cookieConsent.value = "true";
      //cookiesSet.value = true;
    },
    declineCookies: () => {
      consentRaw.value = "false";
      cookieConsent.value = "false";
    //  cookiesSet.value = true;
    },
    resetConsent: () => {
      consentRaw.value = undefined;
      cookieConsent.value = null;
     // cookiesSet.value = false;
    },

    loadExternalScripts,
  };
}
